/* eslint-disable no-shadow */

enum EnumSurveySummaryType {
  MainCard = 'Main Card',
  ListItem = 'List Item',
  OpenQuestion = 'Open Question',
  CheckBox = 'Checkbox Item',
}

export default EnumSurveySummaryType;
